import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getVideoCallEnabled = (configuration: IConfigurationParams[]): boolean => {
  const videoCallParams = configuration?.find((
    params,
  ) => params.name === ConfigurationNames.videoCall);

  return videoCallParams ? JSON.parse(videoCallParams.configuration).enabled : false;
};
